import { render } from "./inner-section.vue?vue&type=template&id=676731e1"
import script from "./inner-section.vue?vue&type=script&lang=js"
export * from "./inner-section.vue?vue&type=script&lang=js"

import "./inner-section.vue?vue&type=style&index=0&id=676731e1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__